<template>
    <div class="text-body1">
        <p>Ne pare rau, dar verificarea adresei de mail <b>{{email}}</b> a esuat!</p>
        <p>Puteti incerca din nou procesul de inregistrare accesand <a :href="url_for_registering">{{url_for_registering}}</a></p>
    </div>
</template>

<script>
    import axios from 'axios';
    import {CONFIG_ENV} from '@/config';

    export default {
        name: "ErrorWhenCheckEmail"
        ,props: ['userid']
        ,data () {
            return {
                email:''
                ,mesaj_from_backend:''
                ,loading: false
                ,url_for_registering:''
            }
        }
        ,methods: {
            getEmailForUserId: function () {
                var vueInst=this;
                axios.get(`${CONFIG_ENV.URL_USER.getEmailForUserId}/${vueInst.userid}`)
                    .then((response)  =>  {
                        this.loading = false;
                        if(response.data.status=='success'){
                            this.email = response.data.email;
                        }

                    }, (error)  =>  {
                        this.loading = false;
                    })
            }
        }
        ,mounted() {
                this.url_for_registering=`${CONFIG_ENV.URL_WWW}/user_register`
        }
    }
</script>

<style scoped>

</style>
